<script>
  import Form from "./Form.svelte";
  import { HStack, VStack, Spacer } from "./layout";
  import { Text, DateField } from "./widget";

  import { trim, capitalize, uppercase } from "../utils.js";
  import { create, load } from "../wedding.js";
  import { navigate } from "../router";

  let step = 1;
  let steps = [
    {
      id: 1,
      name: "Votre mariage",
      done: false,
      back: false,
      cancel: true,
      submit: "continue",
      next: 2,
      prev: null,
    },
    {
      id: 2,
      name: "Informations personnelles",
      done: false,
      back: true,
      cancel: true,
      submit: "continue",
      next: 3,
      prev: 1,
    },
    {
      id: 3,
      name: "Votre formule",
      done: false,
      back: false,
      cancel: false,
      submit: "validate",
      next: 4,
      prev: 2,
    },
    {
      id: 4,
      name: "Félicitations",
      done: false,
      back: false,
      cancel: false,
      submit: "final",
      next: null,
      prev: 3,
    },
  ];

  let form = undefined;

  let current = "";

  let weddingDate = new Date();
  let dateChosen = null;
  let weddingPlace = null;
  let firstname = null;
  let lastname = null;
  let coFirstname = null;
  let coLastname = null;
  let selectedDateFormatted = null;
  let newWedding;

  const submit = async () => {
    console.log("submit", step);
    console.log("weddingDate", weddingDate);

    var timestamp = Math.round(weddingDate.getTime() / 1000);
    console.log("weddingDateTime", timestamp);
    console.log("dateChosen", dateChosen);
    console.log("selectedDateFormatted", selectedDateFormatted);
    console.log("weddingPlace", weddingPlace);
    console.log("firstname", capitalize(firstname));
    console.log("lastname", uppercase(lastname));
    console.log("coFirstname", capitalize(coFirstname));
    console.log("coLastname", uppercase(coLastname));

    if (step == 3) {
      newWedding = await create(
        timestamp,
        trim(weddingPlace),
        capitalize(trim(firstname)),
        uppercase(trim(lastname)),
        capitalize(trim(coFirstname)),
        uppercase(trim(coLastname))
      );
    } else if (step == 4) {
      //close();
      load();
      navigate(`#/dashboard/${newWedding.guid}`);
    }
  };

  function validate(event) {
    switch (event.target.name) {
      default:
        break;
    }
    return true;
  }
</script>

<Form
  bind:form
  bind:step
  bind:steps
  {submit}
  {validate}
  validateButton={"Créer"}
  finalButton={"C'est parti !"}
  on:close
  padding={false}>
  <div>
    {#if step == 1}
      <h1>Votre mariage</h1>

      <p>Quelle est la date prévisionnelle* du mariage&nbsp;?</p>

      <DateField
        id={"weddingDate"}
        required
        bind:selectedDateFormatted
        bind:value={dateChosen}
        bind:selectedDate={weddingDate}
        label="Date"
        bind:current />

      <p>Quel est le lieu prévisionnel* du mariage&nbsp;?</p>

      <!-- wedding place -->
      <Text
        id={"weddingPlace"}
        reset
        bind:value={weddingPlace}
        icon="fa fa-map-marker"
        label="Lieu"
        placeholder="Lieu du mariage"
        bind:current />

      <p class="note">* Vous pourrez modifier cette information plus tard</p>
    {:else if step == 2}
      <h1>Vos informations personnelles&nbsp;:</h1>
      <HStack>
        <VStack margin="0 5px 0 0">
          <p>Vous</p>
          <Text
            id={"firstname"}
            reset
            required
            bind:value={firstname}
            label="Prénom"
            placeholder="Prénom"
            bind:current
            autocomplete={false}
            textTransform={"capitalize"} />
          <Text
            id={"lastname"}
            reset
            required
            bind:value={lastname}
            label="Nom"
            placeholder="Nom"
            bind:current
            autocomplete={false}
            textTransform={"uppercase"} />
        </VStack>
        <Spacer />
        <VStack margin="0 0 0 5px">
          <p>Votre conjoint(e)</p>
          <Text
            id={"coFirstname"}
            reset
            required
            bind:value={coFirstname}
            label="Prénom"
            placeholder="Prénom"
            bind:current
            autocomplete={false}
            textTransform={"capitalize"} />
          <Text
            id={"coLastname"}
            reset
            required
            bind:value={coLastname}
            label="Nom"
            placeholder="Nom"
            bind:current
            autocomplete={false}
            textTransform={"uppercase"} />
        </VStack>
      </HStack>
    {:else if step == 3}
      <h1>Votre formule</h1>

      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam sit amet suscipit dolor.
        Fusce feugiat ut dolor a venenatis. Ut at dapibus eros. Aenean eu felis non urna placerat
        tristique ut vel mauris. Praesent quis pharetra ex. Aliquam imperdiet venenatis ex, eget
        posuere velit lobortis vel. Interdum et malesuada fames ac ante ipsum primis in faucibus.
        Integer ligula quam, finibus sit amet odio eu, fermentum rutrum urna. Donec aliquet quam
        vitae libero mollis commodo. In scelerisque ex nec elit mollis, semper cursus neque luctus.
        Aliquam vel leo id libero cursus molestie. Donec venenatis eu ante eget aliquet.
      </p>
    {:else if step == 4}
      <h1>Félicitations !</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam sit amet suscipit dolor.
        Fusce feugiat ut dolor a venenatis. Ut at dapibus eros. Aenean eu felis non urna placerat
        tristique ut vel mauris. Praesent quis pharetra ex. Aliquam imperdiet venenatis ex, eget
        posuere velit lobortis vel. Interdum et malesuada fames ac ante ipsum primis in faucibus.
        Integer ligula quam, finibus sit amet odio eu, fermentum rutrum urna. Donec aliquet quam
        vitae libero mollis commodo.
      </p>
    {/if}
  </div>
</Form>

<style>
  div {
    height: 400px;
    width: 480px;
  }

  @media screen and (max-width: 600px) {
    div {
      width: 100%;
    }
  }

  h1 {
    font-family: "Cinzel";
    font-size: 1.5rem;
    text-align: center;
  }

  .note {
    font-size: small;
  }
</style>
